import React from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

import { Text, Button, Layout } from '@humanspace/components';
import { Spacing } from '@humanspace/foundations';

const StyledText = styled(Text)`
  margin-bottom: ${Spacing.l};
`;

const StyledButton = styled(Button)`
  margin-top: ${Spacing.xl};
`;

const ResetPasswordConfirmation = () => {
  const history = useHistory();
  return (
    <Layout
      render={
        <>
          <StyledText align="center" size="xl" bold>
            You have successfully changed your password!
          </StyledText>
          <StyledButton onClick={() => history.push('/login')}>
            Done
          </StyledButton>
        </>
      }
    />
  );
};

export default ResetPasswordConfirmation;
